import React from 'react'
import styled from 'styled-components'
// import { media } from '../../../utils/style'
import BrandVw from '../../../vectors/BrandVw'
import BrandKia from '../../../vectors/BrandKia'
import BrandSkoda from '../../../vectors/BrandSkoda'
import BrandVwCommercial from '../../../vectors/BrandVwCommercial'
import BrandSeat from '../../../vectors/BrandSeat'
import BrandCupra from '../../../vectors/BrandCupra'
import BrandGWM from '../../../vectors/BrandGWM'

const StyledBrandGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  pointer-events: none;
  margin: -16px;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.white ? '#fff' : '#3d3e43')};

  svg {
    vertical-align: middle;
  }

  path {
    fill: currentColor;
  }

  > * {
    pointer-events: auto;
    margin: 16px;
  }

  a {
    color: ${(props) => (props.white ? '#fff' : '#3d3e43')};
    display: block;
    transition: all 0.3s ease-in-out;

    &:hover,
    &:focus,
    &:active {
      opacity: 0.6;
      color: ${(props) => (props.white ? '#fff' : '#3d3e43')};
      transition-duration: 0.1s;
    }
  }
`

export const BrandGrid = ({ white }) => {
  return (
    <StyledBrandGrid white={white}>
      <a href="/volkswagen">
        <BrandVw />
      </a>
      <a href="/skoda">
        <BrandSkoda />
      </a>
      <a href="/seat">
        <BrandSeat />
      </a>
      <a href="/vw-commercial">
        <BrandVwCommercial />
      </a>
      <a href="/cupra">
        <BrandCupra />
      </a>
      <a href="/kia">
        <BrandKia />
      </a>
      <a href="/gwm">
        <BrandGWM />
      </a>
    </StyledBrandGrid>
  )
}
